"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeGetProductGroupFredhopper = void 0;
const reselect_1 = require("reselect");
const getProductGroupFredhopper = (state) => state.productGroupFredhopper;
const makeGetProductGroupFredhopper = () => (0, reselect_1.createSelector)(getProductGroupFredhopper, products => products);
exports.makeGetProductGroupFredhopper = makeGetProductGroupFredhopper;
